export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-3xl mx-auto text-center">
        <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 mb-4">手机观影</h2>
        <p className="text-foreground-600 mb-8 max-w-xl mx-auto">
          支持手机浏览器直接访问，无需下载任何APP，打开即看1080P高清影视
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 bg-background-50 rounded-xl p-6 md:p-8">
          <div className="w-16 h-16 flex items-center justify-center bg-primary-100 rounded-2xl">
            <i className="ri-smartphone-line text-3xl text-primary-500"></i>
          </div>
          <div className="text-left">
            <h3 className="text-lg font-semibold text-foreground-900 mb-1">移动端高清观影</h3>
            <p className="text-sm text-foreground-600">
              在手机浏览器输入网址即可直接观看，自适应屏幕尺寸，支持横竖屏切换，
              流量消耗优化，地铁通勤、午休时间随时随地追剧。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}